import React from 'react'
import { Link as LinkRouter } from 'react-router-dom'
import { ReactComponent as Crossclose } from '../../../assets/icones/cross-close.svg'
import '../../../styles/MenuAdmin.css'

function MenuAdmin() {
  return (
    <div id="MenuAdmin" className="menuAdmin">
      <LinkRouter
        to="/FormAdminActualite"
        id="menu-FormAdminActualite"
        className="menuAdminItem menuAdminItemLink"
        onMouseEnter={(e) =>
          e.currentTarget.classList.add('menuAdminItemHover')
        }
        onMouseLeave={(e) =>
          e.currentTarget.classList.remove('menuAdminItemHover')
        }
      >
        Actualités
      </LinkRouter>

      <LinkRouter
        to="/FormAdminEvenement"
        id="menu-FormAdminEvenement"
        className="menuAdminItem menuAdminItemLink"
        onMouseEnter={(e) =>
          e.currentTarget.classList.add('menuAdminItemHover')
        }
        onMouseLeave={(e) =>
          e.currentTarget.classList.remove('menuAdminItemHover')
        }
      >
        Événement
      </LinkRouter>

      <LinkRouter
        to="/FormAdminHorairesTarifs"
        id="menu-FormHorairesTarifs"
        className="menuAdminItem menuAdminItemLink"
        onMouseEnter={(e) =>
          e.currentTarget.classList.add('menuAdminItemHover')
        }
        onMouseLeave={(e) =>
          e.currentTarget.classList.remove('menuAdminItemHover')
        }
      >
        Horaires & Tarifs
      </LinkRouter>

      <LinkRouter to="/" id="pageP" className="btRetourMenuAdmin">
        <Crossclose className="btRetourMenuAdminSvg" />
      </LinkRouter>
    </div>
  )
}

export default MenuAdmin
